/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { searchQuestions } from '../data';
import { searchingQuestionsAction, searchedQuestionsAction, AppState } from '../Store';

import { Title } from '../components/Title';
import { QuestionList } from '../components/QuestionList';
import { Container, Typography, Breadcrumbs, Link } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';

export const Search = () => {
    const dispatch = useDispatch();
    const questions = useSelector((state: AppState) => state.questions.searched);
    const loading = useSelector((state: AppState) => state.questions.loading);
    const [searchParams] = useSearchParams();
    const search = searchParams.get('query') || '';
    const navigate = useNavigate();

    useEffect(() => {
        const doSearch = async (query: string) => {
            dispatch(searchingQuestionsAction());
            const foundResults = await searchQuestions(query);
            dispatch(searchedQuestionsAction(foundResults));
        };

        doSearch(search);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [search]);

    return (
        <>
            {<Title title="Seach results" />}

            <Container maxWidth="lg">
                <Breadcrumbs
                    aria-label="breadcrumb"
                    css={css`
                        padding-top: 20px;
                    `}
                >
                    <Link
                        color="inherit"
                        onClick={() => {
                            navigate('/');
                        }}
                        css={css`
                            display: flex;
                            cursor: pointer;
                        `}
                    >
                        <HomeIcon
                            css={css`
                                margin-right: 5px;
                                width: 20px;
                                height: 20px;
                            `}
                        />
                        Home
                    </Link>
                    <Typography>Search results</Typography>
                </Breadcrumbs>

                <Typography variant="h5" align="center" sx={{ padding: 2 }}>
                    Search results
                </Typography>
                {search && (
                    <p
                        css={css`
                            font-size: 16px;
                            font-weight: bold;
                            font-style: italic;
                            margin-top: 0;
                            margin-left: 2em;
                        `}
                    >
                        {questions.length} results for "{search}"
                    </p>
                )}
                {!loading && <QuestionList data={questions} showCategory={true} showLabels={true} />}
            </Container>
        </>
    );
};
